<template>
  <v-card outlined class="pa-5 my-5">
    {{ name }}
  </v-card>
</template>

<script>
export default {
  name: 'TextContent',

  props: {
    name: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: null
    }
  }
};
</script>
